import { render, staticRenderFns } from "./simple_metric.vue?vue&type=template&id=6ea08cbc"
import script from "./simple_metric.vue?vue&type=script&lang=js"
export * from "./simple_metric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports